import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import axios from "axios";

export default function Logout() {
  const navigate = useNavigate();

  const Logout = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/logout`,
        {},
        { withCredentials: true }
      );
      navigate("/login", { state: undefined });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <button
        onClick={Logout}
        style={{ backgroundColor: "#04AA6D", width: "100%", marginTop: "15px" }}
      >
        Logout
      </button>
    </Box>
  );
}
